<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 3.43056L11.5694 1L1.84722 10.7222L0.875 14.125L4.27778 13.1528L14 3.43056ZM9.625 2.94444L12.0556 5.375L9.625 2.94444ZM1.84722 10.7222L4.27778 13.1528L1.84722 10.7222Z"
      stroke="#09B78A"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
